import * as React from "react";
import {VeboxTreeView} from "../VeboxTreeView";

export interface VeboxTreeViewRadioGroupProps {
    onChange?: (value: any | any[]) => void;
    value?: any | any[];
    disabled?: boolean;
}


export const VeboxTreeViewRadioGroup: React.FC<VeboxTreeViewRadioGroupProps & React.HTMLAttributes<any>> = (props) => {

    const [value, setValue] = React.useState();

    const handleRadioChange = (v) => {
        if (props.onChange) {
            props.onChange(v);
        } else {
            setValue(v);
        }
    }

    return (
        <VeboxTreeView
            {...props}
            className={props.className + (props.disabled ? " vebox-tree-view-disabled" : "")}
            onChange={undefined}
        >
            {React.Children.toArray(props.children)
                .filter(Boolean)
                .map((c: any) => React.cloneElement(
                    c,
                    {
                        ...(c ?? {}).props,
                        onChange: handleRadioChange,
                        parentValue: props.value ?? value,
                        disabled: props.disabled || c.props.disabled
                    }
                ))
            }
        </VeboxTreeView>
    );
}